import { useTheme, useMediaQuery } from '@mui/material';

const useResponsiveScreen = () => {
  const theme = useTheme();
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));

  return {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraSmallScreen,
    isExtraLargeScreen,
    theme,
  };
};

export default useResponsiveScreen;
